export enum Card {
  Article = 'card-article',
  ArticleWhite = 'card-article-white',
  Program = 'card-program',
  Podcast = 'card-podcast',
  School = 'card-school',
  SchoolDistrictPage = 'card-school-district-page',
  Quote = 'card-quote',
}
